var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app container"},[_c('a',{staticClass:"close-button",attrs:{"title":"back"},on:{"click":_vm.handleClose}},[_c('CloseIcon')],1),_c('div',{staticClass:"inner"},[_c('Tos'),_c('PrivacyPolicy')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61604718","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Legal.vue
// module id = null
// module chunks = 